import React from "react";
import VisaApplicationGrid from "../../components/VisaApplicationGrid/VisaApplicationGrid";
import Banner from "../../global/components/Banner";
import "./application.scss";

export default class ApplicationSelect extends React.Component {
  render() {
    return (
      <div className="grey-content-container">
        <div className="usa-profile-header">
          <Banner />
          <div className="usa-header-profile">
            <h3 className="usa-flag-page-header">Choose an Application</h3>
          </div>
        </div>
        <VisaApplicationGrid />
      </div>
    );
  }
}
